import { MenuItem } from '@mui/material';
import { GridExcelExportOptions } from '@mui/x-data-grid-premium';
import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium';
import { MutableRefObject } from 'react';

import { ReportExportOptions } from '~/scenes/PortalModules/Analytics/common';
import { exportToPDF } from '~/scenes/PortalModules/Analytics/common/ReportDataExport/ExportOptionMenuItem/data';

export type ExportOptionMenuItemProps = {
  type: ReportExportOptions;
  label: string;
  options: GridExcelExportOptions;
};

export const ExportOptionMenuItem = (
  exportProps: ExportOptionMenuItemProps & {
    apiRef: MutableRefObject<GridApiPremium>;
    documentDetails: {
      title: string;
      subtitle?: string;
    };
  },
) => {
  const { apiRef, type, label, options, documentDetails } = exportProps;

  const exportDataAsPDF = exportToPDF(apiRef);

  return (
    <MenuItem
      key={`export-${type}`}
      onClick={() => {
        switch (type) {
          case ReportExportOptions.Excel:
            return apiRef?.current?.exportDataAsExcel(options);
          case ReportExportOptions.CSV:
            return apiRef?.current?.exportDataAsCsv(options);
          case ReportExportOptions.PDF:
            return exportDataAsPDF(options, documentDetails);
          default:
            return;
        }
      }}
    >
      {label}
    </MenuItem>
  );
};
